import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectState = (state: ApplicationRootState) =>
    state.app.advertisers || initialState;

export const selectAppAdvertisers = createSelector(
    selectState,
    (state) => state
);

/** Returns an array of advertisers that are currently selected for the global advertiser filter. */
export const selectSelectedAdvertisers = createSelector(
    selectAppAdvertisers,
    ({ data, selectedAdvertiserIds }) =>
        data.filter((a: any) => !!selectedAdvertiserIds[a.advertiser_id])
);

export const selectSelectedAdvertisersState = createSelector(
    selectAppAdvertisers,
    ({ selectedAdvertiserIds }) => selectedAdvertiserIds
);

/** Returns an array of advertisers that are currently selected for the global advertiser filter. */
export const selectSelectedAdvertiserIds = createSelector(
    selectAppAdvertisers,
    ({ data, selectedAdvertiserIds }) => {
        const filteredIds = data.filter(
            (a: any) => !!selectedAdvertiserIds[a.advertiser_id]
        );
        const formattedIds = filteredIds.map((a: any) =>
            Number(a.advertiser_id)
        );
        return formattedIds;
    }
);

export const selectLoadingStatus = createSelector(
    selectState,
    (state) => state.loading
);

export const selectFetchedMemberGroupId = createSelector(
    selectState,
    (state) => state.fetchedMemberGroupId
);

export const selectUseAllAdvertisersOverride = createSelector(
    selectState,
    (state) => state.useAllAdvertisersSelectedOverride
);
